import * as R from 'ramda'
import EventDispatcher from './EventDispatcher'

export default {
  get(key, defaultValue = null) {
    let val = null
    try {
      val = JSON.parse(localStorage.getItem(`PROMETHEUS_${key}`))
    } catch (e) {
      console.warn('Get from local storage error: ', e)
    }
    return R.ifElse(R.isNil, R.always(defaultValue), R.always(val))(val)
  },
  getNested(key, nestedKey, defaultValue = null) {
    let val = null
    try {
      val = JSON.parse(localStorage.getItem(`PROMETHEUS_${key}`))
    } catch (e) {
      console.warn('Get from local storage error: ', e)
    }
    return R.ifElse(
      R.isNil,
      R.always(defaultValue),
      R.propOr(defaultValue, nestedKey),
    )(val)
  },
  save(key, value) {
    try {
      return localStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(value))
    } catch (err) {
      if (/quota/.test(err.message) || /size/.test(err.message)) {
        EventDispatcher.emit('localStorageQuotaExceeded')
      }
      console.error('Local storage save item error', err)
      return false
    }
  },
  saveNested(key, nestedKey, value) {
    const val = JSON.parse(localStorage.getItem(`PROMETHEUS_${key}`)) || {}
    val[nestedKey] = value
    try {
      return localStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(val))
    } catch (err) {
      if (/quota/.test(err.message) || /size/.test(err.message)) {
        EventDispatcher.emit('localStorageQuotaExceeded')
      }
      console.error('Local storage save nested item error', err)
      return false
    }
  },
  remove(key) {
    return localStorage.removeItem(`PROMETHEUS_${key}`)
  },
  removeNested(key, nestedKey) {
    const val = JSON.parse(localStorage.getItem(`PROMETHEUS_${key}`))
    delete val[nestedKey]
    return localStorage.setItem(`PROMETHEUS_${key}`, JSON.stringify(val))
  },
  sizeKb(key) {
    if (key) {
      let xLen = (localStorage[`PROMETHEUS_${key}`].length + `PROMETHEUS_${key}}`.length) * 2
      return (xLen / 1024).toFixed(2)
    } else {
      let _lsTotal = 0,
        _xLen,
        _x
      for (_x in localStorage) {
        // eslint-disable-next-line no-prototype-builtins
        if (!localStorage.hasOwnProperty(_x)) {
          continue
        }
        _xLen = (localStorage[_x].length + _x.length) * 2
        _lsTotal += _xLen
      }
      return (_lsTotal / 1024 / 1024).toFixed(2)
    }
  },
}
